import * as actionTypes from "./actionTypes";
import * as fundservice from "./service";
import { applyFilter } from "../../utils/general";

const log = require("loglevel").getLogger("FundActions");
log.setLevel("error");

export const loadFundById = (id) => {
  return async (dispatch) => {
    log.debug("FundActions -> loadFundById -> Enter");

    const fund = await fundservice.loadFundById(id);

    await dispatch({
      type: actionTypes.FUND_LOADED,
      data: fund,
    });
  };
};

export const loadFunds = (selectedFilters, forceReload) => {
  return async (dispatch) => {
    log.debug("FundActions -> loadFunds -> Enter");

    const result = await fundservice.loadFunds(selectedFilters, forceReload);

    const records = result?.data?.records ?? [];
    const lastUpdated = result?.data?.lastUpdated;

    let filteredFunds = records;

    selectedFilters?.forEach((filter) => {
      filteredFunds = applyFilter(filteredFunds, filter);
    });

    await dispatch({
      type: actionTypes.FUNDS_LOADED,
      data: filteredFunds,
      lastUpdated,
    });
  };
};
